import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../../assets/img/Icons/stage-checkmark-icon.svg'
import _imports_1 from '@/assets/img/Icons/iconRight.svg'


const _hoisted_1 = { class: "new_client" }
const _hoisted_2 = { class: "identification_box" }
const _hoisted_3 = { class: "identification_list" }
const _hoisted_4 = { class: "checked" }
const _hoisted_5 = { href: "#" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = { class: "checked" }
const _hoisted_8 = { href: "#" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_10 = { class: "active" }
const _hoisted_11 = { href: "#" }
const _hoisted_12 = { class: "form_box" }
const _hoisted_13 = { class: "field_wrapper" }
const _hoisted_14 = { class: "field_box" }
const _hoisted_15 = { class: "field form-group" }
const _hoisted_16 = { class: "title_box" }
const _hoisted_17 = { class: "liveness_block_wrapper" }
const _hoisted_18 = { class: "liveness_title" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "error"
}
const _hoisted_21 = { class: "btn_box" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.profile.FirstName) + " " + _toDisplayString(_ctx.profile.SecondName), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("PersonalInformation")) + " ", 1),
            _hoisted_6
          ])
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("a", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Identification")) + " ", 1),
            _hoisted_9
          ])
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$localization.getTranslate("Liveness")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$localization.getTranslate("Liveness")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$localization.getTranslate("IdentificationLivenessTitle")), 1),
            (_ctx.isPassed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$localization.getTranslate("IdentificationLivenessPassedMessage")), 1))
              : _createCommentVNode("", true),
            (!_ctx.isPassed && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-default start-liveness-button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.livenessStart && _ctx.livenessStart(...args)))
                }, _toDisplayString(_ctx.$localization.getTranslate("IdentificationLivenessButtonStart")), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.ErrorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.ErrorMessage), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          class: "ui_continue_button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.GoNext && _ctx.GoNext(...args)))
        }, [
          _hoisted_22,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Continue")), 1)
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_loading, {
              key: 0,
              class: "continue_loading"
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}